import React from 'react';
import PropTypes from 'prop-types';

export default function CheckIcon({ color }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="white" fillOpacity="0.01"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM13.364 9.036L11.212 13.146L9.669 11.756C9.57136 11.6681 9.45738 11.6004 9.33355 11.5566C9.20972 11.5128 9.07848 11.4938 8.94732 11.5007C8.81616 11.5076 8.68764 11.5403 8.56911 11.5969C8.45058 11.6535 8.34435 11.7329 8.2565 11.8305C8.16865 11.9281 8.10088 12.0421 8.05708 12.1659C8.01328 12.2898 7.99429 12.421 8.00121 12.5522C8.00813 12.6833 8.04081 12.8119 8.0974 12.9304C8.15399 13.0489 8.23336 13.1551 8.331 13.243L10.831 15.493C10.9443 15.595 11.0794 15.6698 11.226 15.7116C11.3726 15.7534 11.5268 15.7611 11.6768 15.7342C11.8268 15.7073 11.9687 15.6464 12.0917 15.5563C12.2146 15.4661 12.3153 15.349 12.386 15.214L15.136 9.964C15.2591 9.72902 15.2837 9.45478 15.2046 9.2016C15.1255 8.94843 14.949 8.73706 14.714 8.614C14.479 8.49094 14.2048 8.46627 13.9516 8.54541C13.6984 8.62455 13.4871 8.80102 13.364 9.036Z" fill={color}/>
    </svg>

  )
}

CheckIcon.propTypes = {
  color: PropTypes.string
}
CheckIcon.defaultProps = {
  color: '#31AEFF'
}
